export enum Platform {
  WEB = 'web',
  NATIVE = 'native',
}
